// Chrome and Edge save an MHTML as "name.mhtml.<hex>.partial", then rename it
// when the write finishes. A directory listing can show only the temporary name.

function logicalBankStatementName(fileName) {
  const name = String(fileName || "");
  const match = name.match(/^(.*\.mhtml)\.[0-9a-f]{6,16}\.partial$/i);
  return match ? match[1] : name;
}

function isIgnoredPartial(fileName) {
  const name = String(fileName || "");
  return /partial/i.test(name) && logicalBankStatementName(name) === name;
}

function statementDateKey(fileName) {
  const name = logicalBankStatementName(fileName);
  const tokens = name.match(/\d{6}/g) || [];
  for (let i = tokens.length - 1; i >= 0; i -= 1) {
    const token = tokens[i];
    const month = Number(token.slice(0, 2));
    const day = Number(token.slice(2, 4));
    const year = Number(token.slice(4, 6));
    if (month < 1 || month > 12 || day < 1 || day > 31) continue;
    return (2000 + year) * 10000 + month * 100 + day;
  }
  return 0;
}

function presentIncomingBankFiles(files) {
  const byName = new Map();
  for (const file of files || []) {
    const raw = file && file.name;
    if (!raw || isIgnoredPartial(raw)) continue;
    const logical = logicalBankStatementName(raw);
    const inProgress = logical !== raw;
    const prior = byName.get(logical);
    if (prior && !prior.inProgress) continue;
    if (prior && prior.inProgress && inProgress) {
      const priorTime = new Date(prior.modifiedAt).getTime() || 0;
      const nextTime = new Date(file.modifiedAt).getTime() || 0;
      if (nextTime < priorTime) continue;
    }
    byName.set(logical, {
      name: logical,
      modifiedAt: file.modifiedAt,
      size: file.size,
      inProgress,
    });
  }
  return [...byName.values()].sort((a, b) => {
    const dateDelta = statementDateKey(b.name) - statementDateKey(a.name);
    if (dateDelta) return dateDelta;
    return (new Date(b.modifiedAt).getTime() || 0) - (new Date(a.modifiedAt).getTime() || 0);
  });
}

function pickIncomingBankFile(files, recentNames) {
  const presented = presentIncomingBankFiles(files);
  const recent = new Set((recentNames || []).map((name) => logicalBankStatementName(name)));
  let newestImported = 0;
  for (const name of recent) {
    newestImported = Math.max(newestImported, statementDateKey(name));
  }
  for (const file of presented) {
    if (recent.has(file.name)) continue;
    const key = statementDateKey(file.name);
    if (newestImported && key && key < newestImported) return null;
    if (newestImported && !key) continue;
    return file;
  }
  return null;
}

module.exports = {
  logicalBankStatementName,
  isIgnoredPartial,
  statementDateKey,
  presentIncomingBankFiles,
  pickIncomingBankFile,
};
